import { memo } from "react"
import { TaskHeader } from "routes/schedule/tasks/taskHeader"
import { Task } from "routes/schedule/tasks/task"

// React.memo to prevent every task row from re-rendering when a parent state
// change ripples through the tree. With Repeat's per-item `remove` closure
// stabilized via WeakMap (see lib/@components/repeat.js), default shallow
// equality works correctly: when nothing meaningful changed for this task,
// the row bails out. Inner BoundXXX components subscribe to their specific
// field paths and re-render themselves on field mutations.
export const TaskOrHeader = memo(function TaskOrHeader({ item, index, ...props }) {
    if (!item) return null
    return item.isHeader ? (
        <TaskHeader {...props} item={item} index={index} />
    ) : (
        <Task {...props} item={item} index={index} />
    )
})
